const annualInflationRates: YearDataMapping = {
  1996: 72,
  1997: 74, // copy the rest from this sheet another time
  // ... lots more data in between
  2011: 103,
  2012: 105,
  2013: 107,
  2014: 109,
  2015: 109,
  // everything after here is a projection.
}

export default annualInflationRates;



// WEBPACK FOOTER //
// ./src/data/usdInflationRate.ts